import { createTheme } from '@mui/material/styles'

import { COLORS } from 'constants/colors'

export const fiveDynamicsTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.secondaryBlue.rgba,
      dark: COLORS.blueDeepCerulean.rgba,
    },
    // secondary was pink in v4 — used by decline/delete buttons
    secondary: {
      main: COLORS.primaryPink.rgba,
    },
    error: {
      main: COLORS.primaryPink.rgba,
    },
  },
  components: {
    // ── Form inputs: restore v4 standard (underline) variant ──────────────
    MuiTextField: {
      defaultProps: { variant: 'standard' },
    },
    // @mui/x-date-pickers uses its own internal text field — force standard variant
    MuiPickersTextField: {
      defaultProps: { variant: 'standard' },
    },
    MuiSelect: {
      defaultProps: { variant: 'standard' },
    },
    MuiFormControl: {
      defaultProps: { variant: 'standard' },
    },
    MuiInput: {
      defaultProps: { disableUnderline: false },
    },
    // ── IconButton: restore v4 48px size ─────────────────────────────────
    MuiIconButton: {
      defaultProps: { size: 'large' },
    },
    // ── Button: restore v4 ripple + remove elevation on text/outlined ─────
    MuiButton: {
      defaultProps: { disableElevation: false },
      styleOverrides: {
        // v4 had colour for "default" buttons — now "inherit" — restore grey look
        containedInherit: {
          backgroundColor: '#e0e0e0',
          color: 'rgba(0,0,0,0.87)',
          '&:hover': {
            backgroundColor: '#d5d5d5',
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0,0,0,0.12)',
            color: 'rgba(0,0,0,0.26)',
          },
        },
      },
    },
    // ── Tabs: restore v4 indicator colour ────────────────────────────────
    MuiTabs: {
      defaultProps: { indicatorColor: 'primary' },
    },
    // ── Tab: restore v4 min/max width ─────────────────────────────────────
    MuiTab: {
      defaultProps: { disableRipple: false },
      styleOverrides: {
        root: {
          // v4 had minWidth 72px, v5 changed to 90px
          minWidth: 72,
          '@media (min-width: 600px)': { minWidth: 72 },
        },
      },
    },
    // ── Checkbox: restore v4 secondary colour default ─────────────────────
    MuiCheckbox: {
      defaultProps: { color: 'secondary' },
    },
    // ── Radio: restore v4 secondary colour default ────────────────────────
    MuiRadio: {
      defaultProps: { color: 'secondary' },
    },
    // ── Switch: restore v4 secondary colour default ───────────────────────
    MuiSwitch: {
      defaultProps: { color: 'secondary' },
    },
    // ── Snackbar: restore v4 bottom-center position ───────────────────────
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      },
    },
    // ── Link: restore v4 underline="hover" default ────────────────────────
    MuiLink: {
      defaultProps: { underline: 'hover' },
    },
    // ── Tooltip: restore v4 non-interactive default ───────────────────────
    MuiTooltip: {
      defaultProps: { disableInteractive: true },
    },
    // ── Dialog: restore v4 scroll=paper default ───────────────────────────
    MuiDialog: {
      defaultProps: { scroll: 'paper' },
    },
    // ── Paper: prevent elevation background-image change in dark mode ──────
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: 'unset' } },
    },
    // ── CircularProgress: no breaking change, just ensure size matches v4 ─
    MuiCircularProgress: {
      defaultProps: { size: 40 },
    },
    // ── DatePicker dialog: restore v4 teal header (toolbar + selected day) ─
    MuiDatePickerToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.secondaryBlue.rgba,
          color: '#fff',
          '& .MuiTypography-root': { color: '#fff' },
          '& .MuiDatePickerToolbar-title': { color: '#fff' },
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: COLORS.secondaryBlue.rgba,
            color: '#fff',
            '&:hover': { backgroundColor: COLORS.blueDeepCerulean.rgba },
          },
        },
        today: {
          '&:not(.Mui-selected)': {
            borderColor: COLORS.secondaryBlue.rgba,
          },
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          '& .MuiPickersArrowSwitcher-button': { color: COLORS.secondaryBlue.rgba },
        },
      },
    },
  },
})

export default fiveDynamicsTheme
